import { useMutation, useQuery } from "@tanstack/react-query";
import { apiFetch } from "./apiClient";

/** LDAP directory providers — `/admin/api/v1/directory` (API chain, JWT cookie). */
export interface DirectoryProvider {
  id: string;
  type: string;
  url: string | null;
  baseDn: string | null;
  bindDn: string | null;
  userSearchFilter: string | null;
  available: boolean;
  lastSuccessAt: string | null;
  lastFailureAt: string | null;
  lastFailureReason: string | null;
}

export function useDirectoryProviders() {
  return useQuery({
    queryKey: ["directory", "providers"],
    queryFn: () => apiFetch<DirectoryProvider[]>("/admin/api/v1/directory/providers"),
  });
}

export function useTestProvider() {
  return useMutation({
    mutationFn: (providerId: string) =>
      apiFetch<Record<string, unknown>>(`/admin/api/v1/directory/providers/${encodeURIComponent(providerId)}/test`, { method: "POST" }),
  });
}
